import { EndReasonId, SystemEndReason } from '../cases/index.js';
// Our own registry-agnostic deletion reasons. Each registry maps these to its
// own wire codes in its provider module (e.g. RKI's 3-letter codes, DBR's
// 3-digit removal codes) — raw registry codes must never appear outside those
// modules.
export var DeletionReason;
(function (DeletionReason) {
    DeletionReason["Paid"] = "PAID";
    DeletionReason["AgreementMade"] = "AGREEMENT_MADE";
    DeletionReason["Deceased"] = "DECEASED";
    DeletionReason["CompositionFulfilled"] = "COMPOSITION_FULFILLED";
    DeletionReason["DebtRelief"] = "DEBT_RELIEF";
    DeletionReason["GoodsReturned"] = "GOODS_RETURNED";
    DeletionReason["ForcedSaleCancelled"] = "FORCED_SALE_CANCELLED";
    DeletionReason["Disputed"] = "DISPUTED";
    DeletionReason["Other"] = "OTHER";
})(DeletionReason || (DeletionReason = {}));
export const deletionReasonLabels = {
    [DeletionReason.Paid]: 'Fordring betalt',
    [DeletionReason.AgreementMade]: 'Aftale indgået med skyldner',
    [DeletionReason.Deceased]: 'Skyldner er afgået ved døden',
    [DeletionReason.CompositionFulfilled]: 'Tvangsakkord fyldestgjort',
    [DeletionReason.DebtRelief]: 'Gældssanering - al gæld bortfalder',
    [DeletionReason.GoodsReturned]: 'Varen taget retur',
    [DeletionReason.ForcedSaleCancelled]: 'Tvangsauktion aflyst',
    [DeletionReason.Disputed]: 'Der er strid i sagen',
    [DeletionReason.Other]: 'Andet - vi ønsker skyldner slettet',
};
export const caseEndReasonToDeletionReason = (endReasonId) => {
    switch (endReasonId) {
        case EndReasonId[SystemEndReason.Paid]:
        case EndReasonId[SystemEndReason.PartiallyPaid]:
        case EndReasonId[SystemEndReason.Overpayment]:
            return DeletionReason.Paid;
        case EndReasonId[SystemEndReason.OfferFromDebtor]:
        case EndReasonId[SystemEndReason.OfferFromUs]:
            return DeletionReason.AgreementMade;
        case EndReasonId[SystemEndReason.DebtRelief]:
            return DeletionReason.DebtRelief;
        case EndReasonId[SystemEndReason.Dead]:
            return DeletionReason.Deceased;
        case EndReasonId[SystemEndReason.Objection]:
        case EndReasonId[SystemEndReason.ConflictOfInterest]:
            return DeletionReason.Disputed;
        case EndReasonId[SystemEndReason.Merged]:
            return DeletionReason.Other;
        default:
            return DeletionReason.Other;
    }
};
//# sourceMappingURL=deletion-reason.js.map